import _ from 'lodash';

/**
 * Formats a patient age for display in study lists. Renders the double-hyphen placeholder when the age is nil and collapses anything above 70 into the 70+ bucket.
 *
 * @param age - Patient age in years.
 * @returns The age, the 70+ bucket label, or a placeholder.
 */
const formatPatientAge = (age: any) => (!_.isNil(age) ? (age > 70 ? '70+' : age) : '--');

export { formatPatientAge };
